var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5055 1.08736C17.0678 0.638148 16.42 0.470795 15.816 0.646956L1.73151 4.74271C1.09425 4.91975 0.642563 5.42798 0.520888 6.07361C0.396587 6.73069 0.830765 7.56481 1.398 7.91361L5.80193 10.6203C6.25361 10.8978 6.8366 10.8282 7.21038 10.4512L12.2533 5.37689C12.5072 5.11265 12.9273 5.11265 13.1812 5.37689C13.4351 5.63232 13.4351 6.0463 13.1812 6.31054L8.1295 11.3858C7.75485 11.7619 7.68482 12.3476 7.96056 12.8021L10.6514 17.2502C10.9665 17.7787 11.5093 18.0781 12.1045 18.0781C12.1745 18.0781 12.2533 18.0781 12.3233 18.0693C13.0061 17.9812 13.5488 17.5144 13.7502 16.8538L17.9256 2.78732C18.1095 2.18837 17.9431 1.53657 17.5055 1.08736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.94f6fc41755dd8987157a376a5284ae8.svg";
export { ForwardRef as ReactComponent };